import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    EditableCardComponent,
    EditableCardMode,
} from '@components/atoms/medpace-editable-card/medpace-editable-card.component';
import { MdsRadioButton } from '@medpacesoftwaredevelopment/designsystem';
import { VMCRCCard2 } from '@models/general-models';
import { CRCData } from '@models/site';
import { User } from '@models/user';
import { MdsOptionGeneric, toStringOrFallback } from '@utility/utility';
import { Observable, ReplaySubject, Subject, filter, map, skipWhile, switchMap, takeUntil, tap } from 'rxjs';
@Component({
    selector: 'medpace-crc-card2',
    standalone: false,
    templateUrl: './crc-card2.component.html',
    styleUrls: ['./crc-card2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CRCCard2Component extends EditableCardComponent<CRCData> {
    @Input() set vm(value: VMCRCCard2) {
        this.vmSubject.next(value);
    }
    @Input() mode: EditableCardMode = 'view';
    @Input() showSwitchModeButton: boolean = true;

    protected readonly radioButtons: MdsRadioButton[] = [
        {
            label: 'Yes',
            value: true,
            name: 'hasSupportingCRCs_RadioButton_True',
            id: 'crc-cardYes',
        },
        {
            label: 'No',
            value: false,
            name: 'hasSupportingCRCs_RadioButton_False',
            id: 'crc-cardNo',
        },
    ];
    private readonly vmSubject = new ReplaySubject<VMCRCCard2>();
    private readonly vmObservable$ = this.vmSubject.asObservable();
    private readonly formGroupInit = new Subject<VMCRCCard2>();

    availableOptionsSubject = new ReplaySubject<MdsOptionGeneric<User>[]>();
    availableOptions$ = this.availableOptionsSubject.asObservable();
    supportCRCFilteredOptionsArray: Observable<string[]>[] = [];

    allCrcs: MdsOptionGeneric<User>[] = [];
    allCrcs$ = this.vmObservable$.pipe(
        filter((vm) => !!vm?.crcOptions),
        takeUntil(this.destroySubject),
        map((vm: VMCRCCard2) => vm.crcOptions),
        tap((val) => (this.allCrcs = val))
    );

    constructor() {
        super();
        this.allCrcs$.subscribe();
    }

    public readonly vm$ = this.vmObservable$.pipe(
        skipWhile((vm) => vm === null),
        switchMap((vm: VMCRCCard2) => {
            this.supportCRCFilteredOptionsArray = [];

            return this.vmObservable$;
        })
    );

    getUserByName(name: string): User {
        return this.allCrcs?.find((crc) => crc.viewValue === name)?.value;
    }

    public toCRCInfoContext(context: {
        user: User;
        crcOptions: MdsOptionGeneric<User>[];
        isRemovable: boolean;
        supportingCRCIndex: number;
    }) {
        return context;
    }
    public toUser(user: User) {
        return user;
    }

    public toStringOrFallback(object: Object, fallback: string) {
        return toStringOrFallback(object, fallback);
    }

    public getWarningMessage(options: string[], context: any) {
        return options.length === 0 && context.formControl.untouched && context.vm.value.primaryCRC === null
            ? 'To add a CRC, you must first assign him to study'
            : '';
    }
}
